import {
  CreateHelpDeskTicket,
  UpdateHelpDeskTicket,
} from "../types/help_desk_tickets.types";
import { ResponseData } from "./types";
import { httpClient } from "./common";
import { withApiErrorHandling } from "../APIs/withApiErrorHandling";

export class HelpDeskTicketsAPI {
  private static readonly API_URL = "/help_desk_tickets";

  static async getHelpDeskTickets(): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(this.API_URL, true),
      "Error al obtener los tickets de ayuda"
    );
  }

  static async createHelpDeskTicket(
    data: CreateHelpDeskTicket,
    withAuth: boolean = true
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(this.API_URL, data, withAuth),
      "Error al crear el ticket de ayuda"
    );
  }

  static async getHelpDeskTicket(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${this.API_URL}/${id}`, true),
      "Error al obtener el ticket de ayuda"
    );
  }

  static async updateHelpDeskTicket(
    id: number,
    data: UpdateHelpDeskTicket
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.patch(`${this.API_URL}/${id}`, data, true),
      "Error al actualizar el ticket de ayuda"
    );
  }
}
